import React, { useState } from "react";
import DatePicker from "react-datepicker";

const DatePicker1 = () => {
  const [startDate, setStartDate] = useState();
  console.log(startDate, "startDate");
//   const filterPassedTime = (time) => {
//     const currentDate = new Date();
//     const selectedDate = new Date(time);

//     return currentDate.getTime() < selectedDate.getTime();
//   };
  return (
    <DatePicker
      selected={startDate}
      onChange={(date) => setStartDate(date)}
    //   filterTime={filterPassedTime}
    />
  );
};
export default DatePicker1;
